
import { Accordion, AccordionItem } from "./ui/accordion-custom";
import { Button } from "./ui/button";
import { goToHeroOrderForm } from '@/lib/utils';


const FAQSection = () => {
  
  
  const faqs = [
    {
      question: "Is this really free? What's the catch?",
      answer: "Yes, the book is completely free. You just cover the shipping and handling costs."
    },
    {
      question: "How long will it take to receive my book?",
      answer: "Once your order is received, it will be shipped and delivered within 5-10 business days in the US, and 10-14 business days for international orders."
    },
    {
      question: "Is this only for ERP consultants or can other consultants benefit too?",
      answer: "While the book is tailored for enterprise software consultants (typically known by the term ERP), the principles and strategies apply to most technical consultants looking to go independent."
    },
    {
      question: "What if I'm still employed? Can this still help me?",
      answer: "Absolutely! The book outlines a transition plan that you can implement while still employed, minimizing risk and maximizing your chances of success."
    },
    {
      question: "Do I need to have existing clients to make this work?",
      answer: "No. The book includes detailed strategies for finding and landing your first contract even if you're starting from zero.  Plus, we cover how to get repeat business through building your reputation and sub-contracting with consulting companies."
    }
  ];

  return (
    <section className="dark-section">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
          Frequently Asked Questions
        </h2>
        
        <div className="max-w-3xl mx-auto bg-black/20 rounded-lg p-6 mb-12">
          <Accordion className="text-white">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                title={faq.question}
                defaultOpen={index === 0}
              >
                <p className="text-white/80">{faq.answer}</p>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
